// extracted by mini-css-extract-plugin
export var blue = "_48-g";
export var brand = "_48-c";
export var darkGrey = "_48-f";
export var disabled = "_48-5";
export var disabledSubtle = "_48-6";
export var error = "_48-7";
export var green = "_48-h";
export var grey = "_48-e";
export var icon = "_48-0";
export var inherit = "_48-b";
export var lightGrey = "_48-d";
export var orange = "_48-j";
export var pink = "_48-l";
export var primary = "_48-1";
export var purple = "_48-m";
export var quaternary = "_48-4";
export var red = "_48-k";
export var secondary = "_48-2";
export var success = "_48-a";
export var tertiary = "_48-3";
export var warning = "_48-8";
export var warningSecondary = "_48-9";
export var white = "_48-n";
export var yellow = "_48-i";